
/* -------------------------------------------------------------------------- */
/*                              PLANS                                  */
/* -------------------------------------------------------------------------- */
export const plans = [
  {
    id: 151,
    name: 'Trial',
    type: 'bi-annual',
    provider: 'pitti',
    currency: '€',
    seats: 1,
    amount: 0,
    search_credits: 0,
    crm_allowed: false,
    contact_credit: 10,
    max_search_credits: 10,
    match_credits: 0,
    max_match_credits: 10,
    profile_view_credit: 999999999999999,
    allowed_relations: 1,
    max_allowed_relations: 1,
  },
  {
    id: 152,
    name: 'Entry level',
    type: 'bi-annual',
    provider: 'pitti',
    currency: '€',
    seats: 2,
    amount: 350,
    search_credits: 0,
    crm_allowed: true,
    contact_credit: 75,
    max_search_credits: 40,
    match_credits: 0,
    max_match_credits: 40,
    profile_view_credit: 999999999999999,
    allowed_relations: 1,
    max_allowed_relations: 1,
  },
  {
    id: 153,
    name: 'Exhibitor full',
    type: 'bi-annual',
    provider: 'pitti',
    currency: '€',
    seats: 3,
    contact_credit: 150,
    amount: 1500,
    search_credits: 0,
    crm_allowed: true,
    max_search_credits: 300,
    match_credits: 0,
    max_match_credits: 300,
    profile_view_credit: 999999999999999,
    allowed_relations: 1,
    max_allowed_relations: 1,
  },
  {
    id: 154,
    name: 'No exhibitor',
    type: 'bi-annual',
    provider: 'pitti',
    currency: '€',
    seats: 3,
    amount: 1800,
    search_credits: 0,
    max_search_credits: 300,
    crm_allowed: true,
    contact_credit: 150,
    match_credits: 0,
    max_match_credits: 300,
    profile_view_credit: 999999999999999,
    allowed_relations: 1,
    max_allowed_relations: 1,
  },
];
